/**
 * Icons designed in the studio and added to the font composer, kept in this browser.
 * Each is { name, path, pathSecondary }: paths on the 24 grid, the second drawn at 60%.
 */
const KEY = 'composer-custom'
const EVENT = 'composer-custom-change'

export const MAX_CUSTOM_ICONS = 50

export function readCustomIcons() {
	try {
		const list = JSON.parse(window.localStorage.getItem(KEY))
		return Array.isArray(list) ? list.filter((icon) => icon && icon.name && icon.path) : []
	} catch (e) {
		return []
	}
}

function save(list) {
	try {
		window.localStorage.setItem(KEY, JSON.stringify(list))
	} catch (e) {
		// Storage full or blocked: the change lasts until the page reloads
	}
	window.dispatchEvent(new CustomEvent(EVENT, { detail: list }))
	return list
}

/** Add an icon, or replace the one with the same name */
export function saveCustomIcon(icon) {
	const list = readCustomIcons()
	const index = list.findIndex((item) => item.name === icon.name)
	if (index === -1) list.push(icon)
	else list[index] = icon
	return save(list)
}

export const removeCustomIcon = (name) => save(readCustomIcons().filter((icon) => icon.name !== name))

export const clearCustomIcons = () => save([])

/** Call back with the new list whenever it changes, here or in another tab */
export function onCustomIconsChange(callback) {
	const onLocal = (event) => callback(event.detail)
	const onOther = (event) => {
		if (event.key === KEY) callback(readCustomIcons())
	}
	window.addEventListener(EVENT, onLocal)
	window.addEventListener('storage', onOther)
	return () => {
		window.removeEventListener(EVENT, onLocal)
		window.removeEventListener('storage', onOther)
	}
}
